module.exports = "/_next/static/media/3251c346b575af1a87a8345f42d0d539.svg";